/* loaded by smart-asset */
export default require("./login-artwork-left~LtisYtVB.svg")